import * as React from 'react';

import './umk-modal__suggest-option.scss';

interface IUMKModalSuggestOptionProps {
    value: {
        author: string;
        umk?: string;
    };
}

class UMKModalSuggestOption extends React.Component<IUMKModalSuggestOptionProps> {
    render() {
        const {
            value: { author, umk },
        } = this.props;

        return (
            <div className="umk-modal__suggest-option">
                <div>{author}</div>
                <div className="umk-modal__suggest-option-subtitle">{umk}</div>
            </div>
        );
    }
}

export default UMKModalSuggestOption;
